var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path14, _rect, _rect2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArtPaint = function SvgArtPaint(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93b847",
    d: "M60.04 202.64l-1.52 31.41h50.15l-3.04-31.41H60.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbde",
    d: "M26.1 268.5h116.51l-33.94-34.45H58.52L26.1 268.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffff9",
    d: "M20.52 349.56h125.13l-3.04-81.06H26.1l-5.58 81.06z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#93b847",
    d: "M20.52 349.56h125.13l4.56 75.48H16.98l3.54-75.48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffff9",
    d: "M12.93 504.07h140.32l-3.04-79.03H16.98l-4.05 79.03z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbde",
    d: "M11.91 523.32h142.86l-1.52-19.25H12.93l-1.02 19.25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#16a99e",
    d: "M283.56 523.32l1.52-31.41h-50.16l3.04 31.41h45.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbde",
    d: "M317.5 457.46H200.98l33.94 34.45h50.16l32.42-34.45z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffff9",
    d: "M323.07 376.4H197.94l3.04 81.06H317.5l5.57-81.06z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#16a99e",
    d: "M323.07 376.4H197.94l-4.56-75.48h133.24l-3.55 75.48z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffff9",
    d: "M343.36 212.73H186.77l3.39 88.19h148.68l4.52-88.19z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbde",
    d: "M344.49 191.25H185.07l1.7 21.48h156.59l1.13-21.48z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.39 293.64a134.13 134.13 0 0 1-36.62-33.41c-9.94-13-20.75-28.32-23.85-44.67-4.47-23.54 11.73-39.14 34.37-40.28 10.78-.55 21.58 1.24 32.37.75 8.35-.38 17.2-2.45 22.84-8.62 6.82-7.45 6.7-20.22-.27-27.54-12.37-13-32.21-4.51-47.42-10.09-15-5.51-23.94-19.42-20.53-35.4 2.24-10.5 8.86-19.59 16.54-27.09 18.61-18.19 43.76-28.5 69.3-33.45s51.76-4.92 77.78-5c31-.05 62.66-.13 92.07 9.7 50.81 17 89.78 65 95.9 118.24 6.8 59.09-29.48 125.48-85.64 147.68-26.36 10.43-55.5 10.35-83.84 10.94-32 .66-64.29 2.34-95.68-3.79a141.25 141.25 0 0 1-47.32-17.97zm67.48-197.51l.08-.08c3.31-1.45 4.66-4.18 4.93-7.6 0-1.79.05-3.59.07-5.38-1.33-6.4-5.14-9.75-11.67-10.26l-3.74.08c-4.47.11-6.85 3.22-9.18 6.41a48.74 48.74 0 0 0-8.25 8.18c-4.84 3.85-6.51 9.09-4.58 14.45a13.59 13.59 0 0 0 12.59 8.84c8.51.07 12.59-6.16 17-11.89a3.25 3.25 0 0 0 2.75-2.75zm72.89 189.35c13.09.51 21.74-8.89 22.13-20.93.4-12.27-9.82-22-22.49-21.81-11.21.13-20.53 9.9-20.83 21.2-.31 11.91 11.26 22.91 21.19 21.54zM495 88c-.25-13.18-8.81-21.21-22.32-20.93a20.84 20.84 0 0 0-20.44 21.4c.19 12.44 9.74 21.26 22.75 21 11.74-.18 20.21-9.28 20.01-21.47zm7.42 123.43c-12.57 0-21.86 8.93-21.95 21.21a21.61 21.61 0 0 0 21.6 21.85c12 .15 21.56-9.43 21.58-21.73s-9.04-21.25-21.25-21.3zm-196.71 40.31c-.18 15.28 8.83 19.28 22 20.47 9.12.82 19-8.65 19.09-20.44.13-11.46-10.77-21.67-19.12-20.59-13.58 1.76-22.08 5.26-21.97 20.56z",
    fill: "#d6842d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 326.15,
    cy: 249.12,
    r: 25.29,
    fill: "#93b847"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.23,
    cy: 265.16,
    r: 25.29,
    fill: "#16a99e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.78,
    cy: 229.85,
    r: 25.29,
    fill: "#f0592b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.74,
    cy: 83.52,
    r: 25.29,
    fill: "#6ab4e5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.36,
    cy: 88.4,
    r: 25.29,
    fill: "#f4abe0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.6,
    cy: 152.62,
    r: 25.29,
    fill: "#fdb73e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M386.73 299.91h-.32c-1.77-.28-2.83-2.07-3.63-3.67-2.38-4.73-4.75-9.47-6.68-14.39s-3.46-10.41-6.35-15-7.23-8.69-10.61-13.13C351.83 244 346 233.36 343 221.58a20.71 20.71 0 0 1-.27-3.54c9.83-4 19.68-8 29.43-12.25a7.45 7.45 0 0 1 3.17-.84c3.18.13 4.68 3.86 5.63 6.9 2.1 6.71 5.13 13.1 7.2 19.83s1.75 12.74 2.13 19.58c.76 13.81 8.87 26.08 13.87 38.61a3.49 3.49 0 0 1 .26 2.94 3.43 3.43 0 0 1-1.76 1.3c-4.46 2-9 3.77-13.64 5.34a6.37 6.37 0 0 1-2.29.46z",
    fill: "#dbd9d8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 162.84,
    width: 40.83,
    height: 52.21,
    rx: 2,
    transform: "rotate(-21.94 350.27 188.976)",
    fill: "#015e85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 440.45,
    y: 281.37,
    width: 22.38,
    height: 297.72,
    rx: 1,
    transform: "rotate(-23.07 451.677 430.24)",
    fill: "#f0592b"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArtPaint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/art_paint.1bc78e6d.svg";
export { ForwardRef as ReactComponent };